<template>
  <v-row class="searchInput" row wrap shrink>
    <v-flex shrink px-1 py-1>
      <SimpleSearchInput
        v-model="bookingForm.user.name"
        :loading="loading"
        :customerSelected="customerSelectedName"
        :lookup="lookupByName"
        :customerList="customerListName"
        label="Customer Name"
        :inputChanged="nameChanged"
        :numberChanged="numberChanged"
        itemText="name"
        :error="bookingForm.errors.name"
        :enabled="true"
        :appendIcon="
          bookingForm.user != null && bookingForm.user.locked_out == true
            ? 'lock'
            : null
        "
        width="150px"
        @input="customerSelectedName"
      ></SimpleSearchInput>
    </v-flex>
    <v-flex shrink px-1 py-1>
      <v-row class="flex-nowrap">
        <v-flex shrink>
          <SimpleSearchInput
            v-model="bookingForm.user.contact_number"
            :loading="loading"
            :customerSelected="customerSelectedNumber"
            :lookup="lookupByNumber"
            :inputChanged="numberChanged"
            :customerList="customerListNumber"
            label="Contact No."
            itemText="contact_number"
            :error="bookingForm.errors.contact_number"
            :enabled="true"
            width="130px"
          ></SimpleSearchInput>
        </v-flex>
        <v-flex pl-1 pt-1 shrink v-if="bookingForm.booking.state != null">
          <a :href="'tel:' + formatNumber(bookingForm.user.contact_number)">
            <v-btn
              class="small-fab-phone"
              icon
              flat="flat"
              @click="addingCard = false"
            >
              <v-icon>phone</v-icon>
            </v-btn>
          </a>
        </v-flex>
        <v-flex pl-1 pt-1 v-if="bookingForm.user.name != '' && bookingForm.user.vip_customer && bookingForm.user.id != ''">
          <v-chip
            x-small
            :color="'#E0C6FF'"
            text-color="white"
          >
            VIP
            <v-icon right x-small>
              mdi-star
            </v-icon>
          </v-chip>
        </v-flex>
        <v-flex pl-1 v-if="bookingForm.user.id == '' && bookingForm.user.name">
          <v-checkbox
            dense
            v-model="bookingForm.user.vip_customer"
            :label="'VIP Customer'"
          ></v-checkbox>
        </v-flex>
      </v-row>
    </v-flex>
    <v-flex
      lg7
      pa-1
      pt-2
      v-if="
        bookingForm.user.notes != null &&
        bookingForm.user.notes.length > 0
      "
    >
      <SimpleTextAreaInput
        v-if="
          bookingForm.user.contact_number != null &&
          bookingForm.user.contact_number != ''
        "
        @input="changeUserNotes"
        v-model="bookingForm.user.notes"
        label="Customer Account Notes"
      />
    </v-flex>
  </v-row>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import SimpleSearchInput from "@/components/widget/input/SimpleSearchInput.vue";
import SimpleNumberInput from "@/components/widget/input/SimpleNumberInput.vue";
import SelectableInput from "@/components/widget/input/SelectableInput.vue";
import SimpleTextAreaInput from "@/components/widget/input/SimpleTextAreaInput.vue";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

import { replaceStart } from "@/components/util/PhoneNumbers.js";

export default {
  name: "CustomerSearchInput",
  model: {
    prop: "content",
    event: "input",
  },
  components: {
    BookingDateInput,
    SimpleSearchInput,
    SelectableInput,
    SimpleNumberInput,
    SimpleTextAreaInput,
  },
  props: {
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false,
    },
  },
  computer: {},
  data() {
    return {
      menu: false,
      customerListName: [],
      customerListNumber: [],
      loading: false,
      name: "",
      number: "",
    };
  },
  methods: {
    formatNumber: function (number) {
      return replaceStart(number);
    },
    userIsBusiness: function () {
      return this.bookingForm.user.business == true;
    },
    changeUserNotes: function (notes) {
      this.bookingForm.user.notes = notes;
    },
    nameChanged: function (name) {
      // console.log("Name " + JSON.stringify(name));
    },
    numberChanged: function (number) {
      // console.log("Number " + number);
    },
    customerSelectedName: function (val) {

      if (typeof val === "string") {
        this.bookingForm.clearCustomerId()
        this.bookingForm.user.name = val;
        if (val.length > 0) {
          this.bookingForm.errors.name = null;
        }
      } else {
        this.bookingForm.user.name = val.name;
        this.bookingForm.user.business_user = val.business_user;
        this.bookingForm.user.contact_number = val.contact_number;
        this.bookingForm.getCustomer(val.contact_number);
      }
    },
    customerSelectedNumber: function (val) {

      if (typeof val === "string") {
        this.bookingForm.user.contact_number = val;
        this.bookingForm.clearCustomer();
        // clearing customer could remove promocodes etc
        this.bookingForm.getCostEstimate();

        if (val.length > 0) {
          this.bookingForm.errors.contact_number = null;
        }
      } else {
        this.bookingForm.user.business_user = val.business_user;
        this.bookingForm.user.name = val.name;
        this.bookingForm.user.contact_number = val.contact_number;
        this.bookingForm.getCustomer(val.contact_number);
      }
    },
    lookupByName: function (val) {
      if (val == null) return;
      if (val.length <= 1) return;

      this.name = val;

      var url = `${this.$store.state.apiUrl}/customer/findByName?name=${val}`;

      var searchCompleted = this.searchCompletedName;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (val == vm.name) {
            searchCompleted(res.data);
          }
        })
        .catch(function (err) {
          console.error(err);
          this.loading = false;
        });
    },
    lookupByNumber: function (val) {
      if (val == null) return;
      if (val.length <= 1) return;

      this.number = val;

      var url = `${this.$store.state.apiUrl}/customer/findByNumber?contact_number=${val}`;

      var searchCompleted = this.searchCompletedNumber;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (val == vm.number) {
            searchCompleted(res.data);
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    },
    searchCompletedName: function (data) {
      this.customerListName = data;

      this.loading = false;
    },
    searchCompletedNumber: function (data) {
      this.customerListNumber = data;

      this.loading = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.small-fab-phone {
  transform: scale(0.7);
  transform-origin: left;
}
</style>
